<template>
  <flat-pickr
    v-model="date"
    :config="configs"
    :placeholder="'请选择时间'"
    v-bind="$attrs"
  />
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Mandarin } from "flatpickr/dist/l10n/zh.js";

export default {
  components: {
    flatPickr
  },
  props: {
    value: {
      type: String
    },
    config: {
      type: Object
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      date: this.value,
      configs: {
        locale: Mandarin, //日期控件中文
        ...this.config
      }
    };
  },
  watch: {
    date() {
      this.$emit("change", this.date);
    }
  }
};
</script>
<style scoped>
.flatpickr-input {
  width: 100%;
}
</style>
